export class User {
  constructor() {
    this.password = null;
  }
}